import { useMemo, useState } from "react"
import StepWizard from "../../../../../../commons/StepWizard/StepWizard"
import { CreateAccountManuallyStepsContext } from "./CreateAccountManuallySteps.context"
import { createAccountManuallySteps } from "./CreateAccountManuallySteps.data"
import { CreateAccountManuallyStepsProps } from "./CreateAccountManuallySteps.types"
import { CreateAccountManuallyFormSchema } from "../CreateAccountManuallyButton/CreateAccountManuallyForm/CreateAccountManuallyForm.types"
import { Code } from "../../../../../../../types/models/code/code.types"

export default ({ prospectId }: CreateAccountManuallyStepsProps) => {

  const [accountInfos, setAccountInfos] = useState<CreateAccountManuallyFormSchema>()
  const [signatureInfos, setSignatureInfos] = useState<{
    amount: number;
    fieldsOfActivity: string[];
    duration: number;
    code?: Code;
  }>()

  const contextValue = useMemo(
    () => ({
      prospectId,
      accountInfos,
      setAccountInfos,
      signatureInfos,
      setSignatureInfos
    }),
    [
      prospectId,
      accountInfos,
      setAccountInfos,
      signatureInfos,
      setSignatureInfos
    ]
  )

  return (
    <CreateAccountManuallyStepsContext.Provider value={contextValue}>
      <StepWizard
        steps={createAccountManuallySteps}
        sidebarHidden
        isFullscreen={false}
      />
    </CreateAccountManuallyStepsContext.Provider>
  )
}